import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Upload Product Image
export const uploadImage = createAsyncThunk(
  "uploadImage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`upload/upload-file`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const uploadFileSlice = createSlice({
  name: "uploadFile",
  initialState: initialStates,

  extraReducers: (builder) => {
    builder
      // Upload Product Image
      .addCase(uploadImage.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadImageStatus.data = action.payload;
        state.error = false;
      })
      .addCase(uploadImage.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setUploadFile } = uploadFileSlice.actions;
export default uploadFileSlice.reducer;
